import React from 'react';
import { connect } from 'react-redux';

// @mui/material components
import KSelect from '../KSelect';

class EmrFacilitiesDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      facilities: [],
    };
    this.enableAutoSelectOnUniqueOption = true;
  }

  componentDidMount() {
    this.populateEmrFacilitiesDropdown();
  }

  populateEmrFacilitiesDropdown() {
    const facilities = this.props.emrInfo.facilities;
    const facilityNames = facilities.map((fac) => fac.name);
    const autoSelectFunc = () => this.autoSelectIfJustOneOption();
    this.setState({ facilities: facilityNames }, autoSelectFunc);
  }

  autoSelectIfJustOneOption() {
    if (!this.enableAutoSelectOnUniqueOption) {
      return;
    }
    const facilities = this.state.facilities;
    if (!this.props.value && facilities.length === 1) {
      const quasiEvent = {
        target: {
          value: facilities[0],
        },
      };
      this.props.onChange(quasiEvent);
    }
  }

  render() {
    return (
      <KSelect
        required
        label="Facility *"
        fullWidth={true}
        liveOptions={this.state.facilities}
        value={this.props.value}
        onChange={this.props.onChange}
        disabled={this.props.disabled}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  emrInfo: state.emrInfo,
});

// export default EmrFacilitiesDropdown;

export default connect(mapStateToProps)(EmrFacilitiesDropdown);
